export default __webpack_public_path__ + "static/media/img_app_info_step1.5ab20f42.png";